import Collapsible from "react-collapsible";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import BankTransfers from "./BankTransfers";
import Details from "./Details";
import IncomingPayments from "./IncomingPayments";
import Overview from "./Overview";
import PaymentMessage from "./PaymentMessage";
import Collabse from "../../../components/Collabse";
import { useAppSelector } from "../../../redux/store";
import { useTranslation } from "react-i18next";

const Payments = () => {
  const booking = useAppSelector((state) => state.booking);
  if (booking.isAgencyBooking) return null;

  return (
    <Collabse Header={Header}>
      <div className="row">
        <Overview />
        <Details />
        <BankTransfers />
        <IncomingPayments />
        <PaymentMessage />
      </div>
    </Collabse>
  );
};

const Header = () => {
  const { t } = useTranslation();

  return (
    <h5>
      <FaRegMoneyBillAlt />
      {t("bookingDetails.payments.title")}
    </h5>
  );
};

export default Payments;
